import React, { PureComponent } from 'react'
import queryString from 'query-string'
import { getPrintPreview } from './utils'

export default class UrlVariable extends PureComponent {

	constructor(props){
		super(props)
	}

    getContent = () => {
        const { question } = this.props
        let text = ''
        if (question.content.shortTitle) {
            text = question.content.shortTitle[question.initialLocale]
                ? question.content.shortTitle[question.initialLocale].text
                : ''
        }
        return text
    }

    componentDidMount() {
        const { question, store } = this.props
        if (!store.printMode) {
            const matchedVariables = this.matchUrlVariables()
            store.addFormResponse(question, matchedVariables)
        }
    }

    matchUrlVariables = () => {
        const { question } = this.props
        const { initialLocale } = question
        const { options } = question.optionSet

        const parsed = queryString.parse(window.location.search)
        const r = options.reduce((map, option) => {
            const optionKey = option.langs[initialLocale].text
            map[option.id] = Object.hasOwnProperty.call(parsed, optionKey)
                ? parsed[optionKey]
                : ''
            return map
        }, {})
        return r
    }

    render() {
        const { store, question } = this.props
        return (
            <div>
                {store.printMode &&
                    <div>
                        {getPrintPreview(question, store)}
                        {this.getContent()}
                    </div>
                }
            </div>
        )
    }
}
